import { useTranslates } from 'providers/translates';
import styles from './styles.module.scss';
import MarkdownRenderer from 'components/MarkdownRenderer';

export const TributesExample: React.FC = () => {
  const { translates } = useTranslates();
  const tributesPermissions = translates?.quiltBuilderStepOne?.tributesPermissions;

  return (
    <div className={styles.tributes__example}>
      <span className={styles.tributes__exampleTitle}>{tributesPermissions?.tributesExampleHeading ?? 'Example:'}</span>
      <div className={styles.tributes__exampleInfo}>
        <img src="/img/general/candle-icon.svg" alt="text" />
        <div className={styles.tributes__exampleText}>
          {tributesPermissions?.tributesExampleText ? (
            <MarkdownRenderer content={tributesPermissions?.tributesExampleText} />
          ) : (
            <>
              <span>John and Mary Smith</span>
              <span>
                Our hearts are saddened by your loss and our thoughts and prayers are with you.
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}